var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog } from '../dialog/Dialog';
export const DialogTooltip = (_a) => {
    var { children, content, isOpen, title, setIsOpen } = _a, rest = __rest(_a, ["children", "content", "isOpen", "title", "setIsOpen"]);
    const handleOnClick = () => {
        setIsOpen(true);
        if (children.props.onClick) {
            children.props.onClick();
        }
    };
    const handleDismiss = () => setIsOpen(false);
    return (_jsxs(_Fragment, { children: [React.cloneElement(children, Object.assign(Object.assign({}, children.props), { onClick: handleOnClick })), _jsx(Dialog, Object.assign({ isOpen: isOpen, onDismiss: handleDismiss, title: title }, rest, { children: content }))] }));
};
